export default __webpack_public_path__ + "static/media/mobile-qrScan.0833d259.svg";